"use client"

import React, { useMemo } from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import {
  AvatarWithNameAndTitleContent,
  AvatarWithNameAndTitleSize,
  AvatarWithNameAndTitleSizeVariant,
} from "./AvatarWithNameTitleContent"
import { useRouter } from "next-nprogress-bar"

const UserAvatarWithNameAndTitleFragment = graphql(`
  fragment UserAvatarWithNameAndTitle on User {
    id
    name
    creative {
      id
      __typename
      ... on IndividualCreative {
        id
        handle
        professionString
        displayName
      }
    }

    client {
      id
      __typename
      ... on IndividualClient {
        id
        handle
        jobTitle
        company
      }
    }

    ...AvatarWithNameAndTitleContent
  }
`)

interface Props {
  user: FragmentType<typeof UserAvatarWithNameAndTitleFragment> | null | undefined
  size: AvatarWithNameAndTitleSize
  variant: AvatarWithNameAndTitleSizeVariant
  className?: string
  isCreative: boolean
}

export const UserAvatarWithNameAndTitle: React.FC<Props> = props => {
  const user = useFragment(UserAvatarWithNameAndTitleFragment, props.user)

  const { className, size, variant, isCreative } = props
  const router = useRouter()

  const { title, subtitle } = useMemo(() => {
    if (isCreative) {
      return {
        title: user?.creative?.displayName || user?.name,
        subtitle: user?.creative?.professionString,
      }
    } else {
      return {
        title: user?.name,
        subtitle:
          user?.client?.jobTitle && user?.client?.company
            ? `${user?.client?.jobTitle} at ${user?.client?.company}`
            : user?.client?.jobTitle,
      }
    }
  }, [isCreative, user])

  return (
    <div
      className="cursor-pointer"
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        isCreative ? router.push(`/${user?.creative?.handle}`) : router.push(`/clients/${user?.client?.handle}`)
      }}>
      <AvatarWithNameAndTitleContent
        title={title}
        subtitle={subtitle}
        className={className}
        variant={variant}
        size={size}
        user={user}
      />
    </div>
  )
}
